import { memo } from 'react'
import {
    buildControlsExt,
    dateTimePicker,
} from '../inputs/controls'
import { TimeFormats } from '../models/DateTime/types'

interface DateToFilterProps {
    inputState: any
    setInputState: Function
}

export const DateToFilter = memo(function DateToFilter(
    props: DateToFilterProps
) {
    const { inputState, setInputState } = props

    const dateToPicker = buildControlsExt(
        [
            dateTimePicker(
                'to',
                {
                    className: 'mb-2 label-sm',
                    timeFormat: TimeFormats.DATE,
                },
                false,
                true
            ),
        ],
        inputState,
        setInputState
    )

    return (
        <div className=" d-flex flex-column gap-1">
            <span>To</span>
            <div className="w-100">
                {dateToPicker}
            </div>
        </div>
    )
})